import { PromoData, Receipt } from '@lib/types';

export function calculateTaxes(receipt: Receipt): number {
  const { tax, taxOnDelivery, deliveryFee, subTotal, subTotalAfterDiscount } =
    receipt;

  if (!tax) {
    return 0;
  }
  const deliveryTax = taxOnDelivery ? (deliveryFee * tax) / 100 : 0;
  const subTotalTax = ((subTotalAfterDiscount || subTotal) * tax) / 100;
  const totalTaxes = deliveryTax + subTotalTax;
  return totalTaxes;
}

export function calculatePromoValue(
  receipt: Receipt,
  userPromo: PromoData,
): number {
  const { total, subTotalAfterDiscount, subTotal } = receipt;
  if (userPromo) {
    if (userPromo.discount) {
      const redeemedValue = Math.ceil((userPromo.discount * (subTotalAfterDiscount || subTotal)) / 100);
      return redeemedValue > userPromo.maxMoneyValue
        ? userPromo.maxMoneyValue
        : redeemedValue;
    } else {
      return total === 0 ? total : userPromo.maxMoneyValue;
    }
  } else {
    return 0;
  }
}

export function calculateTotal(receipt: Receipt): number {
  let totalToPay = receipt.total - receipt.deliveryFee - receipt.driverTip;
  totalToPay = Math.round(totalToPay * 100) / 100;
  return totalToPay;
}
